import _ from 'lodash'

// 通用平台列表，多个项目公用的配置，不可随意变更
export const platformList = [
  {
    value: 'ios',
    label: 'iOS'
  },
  {
    value: 'android',
    label: 'Android'
  },
  {
    value: 'ios,android',
    label: 'iOS & Android'
  }
]

/**
 * 用 os value 交换 os label
 * @param {string|number|array} val
 * @param {{}[]} [list] 可选参数，平台列表
 */
export const useValueExchangePlatform = (val, list = platformList) => {
  if (_.isArray(val)) {
    return val.filter(item => !!item).sort(() => {
      return -1
    }).map(id => {
      return (list.find(os => os.value === String(id)) || {}).label
    }).join()
  }
  return list.find(os => os.value === String(val)).label
}
